var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMediumColored(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 2629",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconMediumColored_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2442",
    fill: "none",
    d: "M0 0h80v80H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2628",
    clipPath: "url(#iconMediumColored_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20532",
    d: "M40 0A40 40 0 110 40 40 40 0 0140 0",
    fill: "#e0feff"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20533",
    d: "M65.766 39.306h-.26l-17.25-17.407-.062-.032a1.142 1.142 0 00-1.335.2L39.97 28.93l-6.763-6.809a1.191 1.191 0 00-1.73 0L14.34 39.509l-.032.1a1.317 1.317 0 00.346 1.38l.03.038a24.5 24.5 0 002.616 2.634c.5.453.965.881 1.377 1.293 2.263 2.26 4.547 4.577 6.755 6.818 1.977 2.007 4.022 4.082 6.041 6.1a1.191 1.191 0 001.728 0l6.768-6.814 6.9 6.875a1.167 1.167 0 00.8.324 1.144 1.144 0 00.527-.13l.062-.032 17.509-17.561zm-15.266.975l-.47-1.18-8.309-8.382 5.946-6 15.146 15.366-15.139 15.2-5.951-6zm-3.016-.135l-7.511 7.353-7.447-7.5 7.51-7.494zm-17.478-1.067a1.4 1.4 0 00-.368 1.326l.033.091 8.618 8.784-5.95 6L17.2 40.08l15.141-15.362 5.946 6-8.244 8.317z",
    fill: "#058181"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMediumColored);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/iconMediumColored.0cdc57b1.svg";
export { MemoForwardRef as ReactComponent };